import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function ProntuarioForm() {
    const [nome, setNome] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [idade, setIdade] = useState('');
    const [sexo, setSexo] = useState('');
    const [cpf, setCpf] = useState('');
    const [telefone, setTelefone] = useState('');
    const [telefoneEmergencia, setTelefoneEmergencia] = useState('');
    const [email, setEmail] = useState('');
    const [cidadeEstado, setCidadeEstado] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [profissao, setProfissao] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [textoLivre, setTextoLivre] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
        }
    }, [navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        
        const payload = { 
            nome, 
            data_nascimento: dataNascimento, 
            idade, 
            sexo, 
            cpf, 
            telefone, 
            telefone_emergencia: telefoneEmergencia, 
            email, 
            cidade_estado: cidadeEstado, 
            estado_civil: estadoCivil, 
            profissao, 
            empresa, 
            texto_livre: textoLivre 
        };

        axios.post('https://ipj-api.vercel.app/api/prontuarios', payload, {
            headers: {
                'Authorization': token
            }
        })
            .then(() => navigate('/prontuarios'))
            .catch(error => console.error(error));
    };

    return (
        <div className="prontuario-form-container">
            <h2>Criar Prontuário</h2>
            <form onSubmit={handleSubmit}>
                <input type="text" placeholder="Nome Completo" value={nome} onChange={(e) => setNome(e.target.value)} required />
                <input type="date" placeholder="Data de Nascimento" value={dataNascimento} onChange={(e) => setDataNascimento(e.target.value)} />
                <input type="number" placeholder="Idade" value={idade} onChange={(e) => setIdade(e.target.value)} />
                <input type="text" placeholder="Sexo" value={sexo} onChange={(e) => setSexo(e.target.value)} />
                <input type="text" placeholder="CPF" value={cpf} onChange={(e) => setCpf(e.target.value)} />
                <input type="text" placeholder="Telefone/WhatsApp" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
                <input type="text" placeholder="Telefone de Emergência" value={telefoneEmergencia} onChange={(e) => setTelefoneEmergencia(e.target.value)} />
                <input type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
                <input type="text" placeholder="Cidade/Estado" value={cidadeEstado} onChange={(e) => setCidadeEstado(e.target.value)} />
                <input type="text" placeholder="Estado Civil" value={estadoCivil} onChange={(e) => setEstadoCivil(e.target.value)} />
                <input type="text" placeholder="Profissão/Ocupação" value={profissao} onChange={(e) => setProfissao(e.target.value)} />
                <input type="text" placeholder="Empresa" value={empresa} onChange={(e) => setEmpresa(e.target.value)} />
                <textarea placeholder="Texto Livre" value={textoLivre} onChange={(e) => setTextoLivre(e.target.value)} />
                <button type="submit">Salvar</button>
            </form>
        </div>
    );
}

export default ProntuarioForm;